import script from "./PageHeaderActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeaderActions.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeaderActions.vue?vue&type=style&index=0&id=006ea2d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006ea2d2"]])

export default __exports__